module.exports = __webpack_public_path__ + "static/media/emotion.70cdd971.svg";